import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import {
  ControlContainer,
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { HttpService } from 'src/app/core/services/http.service';

@Component({
  selector: 'app-product-name-field',
  templateUrl: './product-name-field.component.html',
  styleUrls: ['./product-name-field.component.scss'],
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
})
export class ProductNameFieldComponent {
  @Input('lob') lob: any;
  @Input('allRuleIdData') allRuleIdData: any;
  product: any = [];

  form: FormGroup;

  productControl = new FormControl();
  @Input('required') isRequired = false;
  lobSelected: any = '';

  constructor(
    private ctrlContainer: FormGroupDirective,
    private http: HttpService
  ) {}

  ngOnInit(): void {
    this.form = this.ctrlContainer.form;

    if (this.form.value['product_name']) {
      this.productControl.setValue(this.form.value['product_name']);
    }
    this.form.addControl('product_name', this.productControl);
    this.getProduct();
  }
  getProduct() {
    const url = '/services/api/v1/rb_masters/sme_product';
    this.http.get(url).subscribe((res: any) => {
      this.product = res['data'];
      if (this.form.value['product_name']) {
        this.productControl.setValue(this.form.value['product_name']);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['lob']) {
      if (changes['lob'].currentValue !== '') {
        this.lobSelected = changes['lob'].currentValue;

        if (this.form === undefined) {
          this.form = this.ctrlContainer.form;
          if (this.form.value['product_name']) {
            this.productControl.setValue(this.form.value['product_name']);
          }
          this.form.addControl('product_name', this.productControl);
        }

        if (this.lobSelected === 'sme') {
          this.form.get('product_name')?.setValidators([Validators.required]);
          this.form.get('product_name')?.updateValueAndValidity();
        } else {
          this.form.get('product_name')?.setValidators([]);
          this.form.get('product_name')?.updateValueAndValidity();
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.form.removeControl('product_name');
  }
}
